import { render, staticRenderFns } from "./PagadorAseguradora.vue?vue&type=template&id=74801d89&scoped=true"
import script from "./PagadorAseguradora.vue?vue&type=script&lang=js"
export * from "./PagadorAseguradora.vue?vue&type=script&lang=js"
import style0 from "./PagadorAseguradora.vue?vue&type=style&index=0&id=74801d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74801d89",
  null
  
)

export default component.exports